if (!customElements.get('footer-disclosure')) {
  customElements.define('footer-disclosure', class extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      if (!this.details || !this.summary) return;

      this.desktop = window.matchMedia('(min-width: 750px)');
      this.mobileOpen = this.hasAttribute('data-open-mobile');
      this.onViewportChange = () => this.syncViewport();
      this.onClick = (event) => {
        if (this.desktop.matches) event.preventDefault();
      };
      this.onToggle = () => {
        if (!this.desktop.matches) this.mobileOpen = this.details.open;
        this.summary.setAttribute('aria-expanded', String(this.details.open));
      };

      if (this.summary.nextElementSibling?.id) {
        this.summary.setAttribute('aria-controls', this.summary.nextElementSibling.id);
      }
      this.summary.addEventListener('click', this.onClick);
      this.details.addEventListener('toggle', this.onToggle);
      this.desktop.addEventListener('change', this.onViewportChange);
      this.syncViewport();
    }

    syncViewport() {
      this.details.open = this.desktop.matches || this.mobileOpen;
      this.summary.setAttribute('aria-expanded', String(this.details.open));
      if (this.desktop.matches) {
        this.summary.setAttribute('aria-disabled', 'true');
        this.summary.setAttribute('tabindex', '-1');
      } else {
        this.summary.removeAttribute('aria-disabled');
        this.summary.removeAttribute('tabindex');
      }
    }

    disconnectedCallback() {
      this.summary?.removeEventListener('click', this.onClick);
      this.details?.removeEventListener('toggle', this.onToggle);
      this.desktop?.removeEventListener('change', this.onViewportChange);
    }
  });
}
